module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av360-ce1254fac506e3e12eccb427ae87ddc8.jpg";